import { create } from 'zustand';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface UIState {
  /** 侧边栏是否折叠（桌面端） */
  sidebarCollapsed: boolean;
  /** 移动端侧边栏是否打开（临时 Drawer） */
  mobileSidebarOpen: boolean;
  /** 面包屑 */
  breadcrumbs: BreadcrumbItem[];
  /** 切换侧边栏折叠（桌面端） */
  toggleSidebar: () => void;
  /** 打开移动端侧边栏 */
  openMobileSidebar: () => void;
  /** 关闭移动端侧边栏 */
  closeMobileSidebar: () => void;
  /** 设置面包屑 */
  setBreadcrumbs: (items: BreadcrumbItem[]) => void;
}

export const useUIStore = create<UIState>()((set) => ({
  sidebarCollapsed: false,
  mobileSidebarOpen: false,
  breadcrumbs: [],
  toggleSidebar: () =>
    set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
  openMobileSidebar: () => set({ mobileSidebarOpen: true }),
  closeMobileSidebar: () => set({ mobileSidebarOpen: false }),
  setBreadcrumbs: (items) => set({ breadcrumbs: items }),
}));
